import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import RepaymentTestUpdateModalUI from './RepaymentTestUpdateModalUI.js'

class RepaymentTestUpdateModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            submitted: false,
            scheduledDateISO: null,
            scheduledDateISOError: null,
            defaultInterest: null,
            defaultInterestError: null,
            defaultInterestPaid: null,
            defaultInterestPaidError: null,
            interestOnOverduePrincipal: null,
            interestOnOverduePrincipalError: null,
            interestOnOverduePrincipalPaid: null,
            interestOnOverduePrincipalPaidError: null,
            interestOnOverdueInterest: null,
            interestOnOverdueInterestError: null,
            interestOnOverdueInterestPaid: null,
            interestOnOverdueInterestPaidError: null,
            interestPaid: null,
            interestPaidError: null,
            principalPaid: null,
            principalPaidError: null
        }
    }

    render() {
        return (
            <RepaymentTestUpdateModalUI
                context={this.props.context}
                errorList={this.state.errorList}

                updateMode={this.props.updateMode}
                clearDataMode={this.props.clearDataMode}
                submitted={this.state.submitted}
                status={this.state.status}
                // event handlers
                onCancelClick={this.props.onCancelClick}
                onClearDataCancelClick={this.props.onClearDataCancelClick}
                onSubmit={this.onSubmit}
                onClearDataClick={this.onClearDataClick}
                // form fields
                scheduledDateISO={this.state.scheduledDateISO}
                onScheduledDateISOChange={(event) => { this.setState({ scheduledDateISO: event.target.value }) }}
                scheduledDateISOError={this.state.scheduledDateISOError}
                setScheduledDateISOError={(error) => { this.setState({ scheduledDateISOError: error }) }}

                defaultInterest={this.state.defaultInterest}
                onDefaultInterestChange={(event) => { this.setState({ defaultInterest: event.target.value }) }}
                defaultInterestError={this.state.defaultInterestError}
                setDefaultInterestError={(error) => { this.setState({ defaultInterestError: error }) }}

                defaultInterestPaid={this.state.defaultInterestPaid}
                onDefaultInterestPaidChange={(event) => { this.setState({ defaultInterestPaid: event.target.value }) }}
                defaultInterestPaidError={this.state.defaultInterestPaidError}
                setDefaultInterestPaidError={(error) => { this.setState({ defaultInterestPaidError: error }) }}

                interestOnOverduePrincipal={this.state.interestOnOverduePrincipal}
                onInterestOnOverduePrincipalChange={(event) => { this.setState({ interestOnOverduePrincipal: event.target.value }) }}
                interestOnOverduePrincipalError={this.state.interestOnOverduePrincipalError}
                setInterestOnOverduePrincipalError={(error) => { this.setState({ interestOnOverduePrincipalError: error }) }}

                interestOnOverduePrincipalPaid={this.state.interestOnOverduePrincipalPaid}
                onInterestOnOverduePrincipalPaidChange={(event) => { this.setState({ interestOnOverduePrincipalPaid: event.target.value }) }}
                interestOnOverduePrincipalPaidError={this.state.interestOnOverduePrincipalPaidError}
                setInterestOnOverduePrincipalPaidError={(error) => { this.setState({ interestOnOverduePrincipalPaidError: error }) }}

                interestOnOverdueInterest={this.state.interestOnOverdueInterest}
                onInterestOnOverdueInterestChange={(event) => { this.setState({ interestOnOverdueInterest: event.target.value }) }}
                interestOnOverdueInterestError={this.state.interestOnOverdueInterestError}
                setInterestOnOverdueInterestError={(error) => { this.setState({ interestOnOverdueInterestError: error }) }}

                interestOnOverdueInterestPaid={this.state.interestOnOverdueInterestPaid}
                onInterestOnOverdueInterestPaidChange={(event) => { this.setState({ interestOnOverdueInterestPaid: event.target.value }) }}
                interestOnOverdueInterestPaidError={this.state.interestOnOverdueInterestPaidError}
                setInterestOnOverdueInterestPaidError={(error) => { this.setState({ interestOnOverdueInterestPaidError: error }) }}

                interestPaid={this.state.interestPaid}
                onInterestPaidChange={(event) => { this.setState({ interestPaid: event.target.value }) }}
                interestPaidError={this.state.interestPaidError}
                setInterestPaidError={(error) => { this.setState({ interestPaidError: error }) }}

                principalPaid={this.state.principalPaid}
                onPrincipalPaidChange={(event) => { this.setState({ principalPaid: event.target.value }) }}
                principalPaidError={this.state.principalPaidError}
                setPrincipalPaidError={(error) => { this.setState({ principalPaidError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.put(this.props.context,
            `/api/su/test/loans/${this.props.loan.loanId}/scheduledDate/${this.state.scheduledDateISO}/emiV2`,
            this.onSubmitCallback, {
            defaultInterest: this.state.defaultInterest,
            defaultInterestPaid: this.state.defaultInterestPaid,
            interestOnOverduePrincipal: this.state.interestOnOverduePrincipal,
            interestOnOverduePrincipalPaid: this.state.interestOnOverduePrincipalPaid,
            interestOnOverdueInterest: this.state.interestOnOverdueInterest,
            interestOnOverdueInterestPaid: this.state.interestOnOverdueInterestPaid,
            interestPaid: this.state.interestPaid,
            principalPaid: this.state.principalPaid
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    onClearDataClick = () => {
        let submitted = this.state.submitted
        if (submitted)
            return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.delete(this.props.context, `/api/su/test/loans/${this.props.loan.loanId}/scheduledDate/${this.state.scheduledDateISO}/deleteChargeAmountList`,
            this.onClearDataClickCallback, null, null
        )
    }

    onClearDataClickCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false,
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default RepaymentTestUpdateModalSF
